import { memo } from 'react'
import { SxProps } from '@mui/material'
import { useTranslations } from '@/core/translation'
import { FlashIcon, Phone02Icon, ShieldTickIcon, Users02Icon } from '@/assets'
import { SummaryCardActions } from '@/components/Composed'
import { eventDetailsStyles as styles } from './EventDetails.style'
import { Box } from '@/components/Layout'
import { Chip, Text } from '@/components/Data'
import Map from '@/components/Surface/Map'
import { useEventDetailsController } from './EventDetails.controller'
import { markerClasses } from '@/components/Surface/Map/Marker'
import { EventDetailsProps } from './EventDetails.types'

function EventDetails({ hideLocationInfo = false }: EventDetailsProps) {
  const t = useTranslations('addOn')
  const tTickets = useTranslations('tickets')

  const {
    eventDetails: { event, ticket, location },
    isEditActionDisabled,
    isSingleProduct,
    locations,
    centerLocation,
    onTicketEditClick,
    onTicketRemoveClick,
  } = useEventDetailsController()

  return (
    <>
      {/* <Box>
        <Text sx={styles.limitedSeats}>{t('limitedSeats')}</Text>
      </Box> */}

      {event && (
        <Box>
          <Text sx={styles.title}>{event.name}</Text>
          <Text sx={[styles.infoText, styles.eventTime] as SxProps}>{event.time}</Text>
        </Box>
      )}

      {ticket && (
        <Box>
          <Text sx={styles.leadText}>{t('ticketInfo')}</Text>
          <Text sx={styles.infoText}>{t('numberOfTicket', { ticket: ticket.quantity })}</Text>
          <Text sx={[styles.infoText, styles.details] as SxProps}>{ticket.details}</Text>
          <Box sx={styles.chipsWrapper}>
            {ticket.isMobileTicket && (
              <Chip label={tTickets('mobileTicket')} icon={<Phone02Icon />} color="default" />
            )}
            {ticket.isInstantDelivery && (
              <Chip
                label={tTickets('list.instantDelivery')}
                icon={<FlashIcon />}
                color="grayBlue"
              />
            )}
            <Chip label={tTickets('verified')} icon={<ShieldTickIcon />} />
            {ticket.isAccessible && (
              <Chip label={tTickets('accessible')} icon={<Users02Icon />} color="grayBlue" />
            )}
          </Box>
        </Box>
      )}

      {!hideLocationInfo && (
        <>
          {location && (
            <Box>
              <Text sx={styles.leadText}>{t('location')}</Text>
              <Text sx={styles.infoText}>{location.name}</Text>
              <Text sx={styles.infoText}>{location.address}</Text>
            </Box>
          )}

          <Box sx={styles.mapView}>
            {locations.length > 0 && (
              <Map
                mapWrapperProps={{ className: markerClasses.size.xs, sx: styles.mapView }}
                locations={locations}
                autoFitPinZoom
                centerLocation={centerLocation}
              />
            )}
          </Box>

          {location && (
            <Box>
              <Text sx={styles.infoText}>{location.fromAirport}</Text>
              <Text sx={styles.infoText}>{location.fromCityCenter}</Text>
            </Box>
          )}
        </>
      )}

      {ticket && (
        <SummaryCardActions
          onEditClick={onTicketEditClick}
          onRemoveClick={onTicketRemoveClick}
          isActionDisabled={isEditActionDisabled}
          isRemoveActionDisabled={isSingleProduct}
        />
      )}
    </>
  )
}

export default memo(EventDetails)
